<style lang="scss">
  @use "../../assets/css/design-system/colors";
  @use "../../assets/css/design-system/utils";

  a {
    display: flex;
    border: solid 1px transparent;
    border-radius: 6px;
    cursor: pointer;
    justify-content: center;
    text-align: center;
    align-items: center;

    &.xxs {
      height: utils.in_rem(16px);
      width: utils.in_rem(16px);
    }
    &.xs {
      height: utils.in_rem(20px);
      width: utils.in_rem(20px);
    }

    &.small {
      height: utils.in_rem(24px);
      width: utils.in_rem(24px);
    }

    &.medium {
      height: utils.in_rem(34px);
      width: utils.in_rem(34px);
    }

    &.xl {
      height: utils.in_rem(54px);
      width: utils.in_rem(54px);
    }
  }
</style>

<script>
  import Icon from "./Icon.svelte";
  import Tooltip from "./Tooltip.svelte";

  export let icon;
  export let href;
  /** @type {"xxs", "xs", "small" | "medium" | "large" | "xl"} */
  export let size = "medium";
  export let color;
  export let skeleton = false;
  export let placement;

  let cls = "";
  export { cls as class };

  // Sometimes links have no https://, so we need to add it, otherwise
  // the link directs to sourcewhale.app/<link> which would be undefined
  const wrappedHref = (url) =>
    url && !url.startsWith("http") ? `https://${url}` : url;

  // Icon sizes do not match the sizes above, so need a mapping
  const iconSizes = {
    xxs: "medium", // 16px
    xs: "large", // 20px
    small: "xl", // 24px
    medium: "xxl", // 34px
    xl: "xxxl", // 54px
  };

  // Convert linkedIn gold color to a color defined in our design system
  $: color = color === "gold" ? "accentLinkedInPremiumGold" : color;
</script>

{#if $$slots.tooltip}
  <Tooltip {placement} let:onmouseenter let:onmouseleave let:onblur let:onfocus>
    <a
      class="{cls} {size}"
      href={wrappedHref(href)}
      target="_blank"
      rel="noopener noreferrer"
      {...$$restProps}
      class:skeleton
      on:mouseenter={onmouseenter}
      on:mouseleave={onmouseleave}
      on:focus={onfocus}
      on:blur={onblur}
    >
      {#if !skeleton}
        <Icon class="{icon} color-{color}" size={iconSizes[size]} />
      {/if}
    </a>
    <span slot="tooltip"><slot name="tooltip" /></span>
  </Tooltip>
{:else}
  <a
    class="{cls} {size}"
    href={wrappedHref(href)}
    target="_blank"
    rel="noopener noreferrer"
    {...$$restProps}
    class:skeleton
  >
    {#if !skeleton}
      <Icon class="{icon} color-{color}" size={iconSizes[size]} />
    {/if}
  </a>
{/if}
